import React, { useMemo } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'

const FONTS = [
  {
    family: 'Open Sans Condensed',
    weight: 'normal',
    src: 'local("Open Sans Condensed"), url(https://themes.googleusercontent.com/static/fonts/opensanscondensed/v6/gk5FxslNkTTHtojXrkp-xLF0I8LnmRdLRTOvKd-OXMQ.woff) format("woff")'
  }
]

const APPEARANCE = {
  theme: 'stripe'
}

const StripeWrapper = props => {
  const {
    appSettings,
    children,
    mode,
    amount,
    currency,
    account,
    customerSessionClientSecret
  } = props
  const { stripeApiKey } = appSettings
  const stripePromise = useMemo(() => loadStripe(stripeApiKey), [stripeApiKey])

  const options = useMemo(() => {
    // Payment Intents mode with deferred intent creation.
    // When mode/amount are provided, configure Elements for PaymentElement rendering.
    // When omitted (e.g. confirm page), only the stripe instance is needed.
    if (!mode) {
      return { fonts: FONTS }
    }

    return {
      mode,
      amount,
      currency: currency || 'usd',
      paymentMethodCreation: 'manual',
      appearance: APPEARANCE,
      paymentMethodOptions: {
        // do not allow microdeposit fallback for Financial Connections
        us_bank_account: {
          verification_method: 'instant'
        }
      },
      ...(customerSessionClientSecret && { customerSessionClientSecret })
    }
  }, [mode, amount, currency, account, customerSessionClientSecret])

  return (
    <Elements stripe={stripePromise} options={options}>
      {children}
    </Elements>
  )
}

export default StripeWrapper
